/* eslint-disable no-underscore-dangle */
import { useEffect } from "react";
import * as Scrivito from "scrivito";

export function useMatomo({ siteId, trackerUrl, allowed }) {
  useEffect(() => {
    const trackerScriptUrl = `${trackerUrl}matomo.js`;

    if (Scrivito.isEditorLoggedIn()) return;
    if (!siteId || !trackerUrl || !trackerScriptUrl || !allowed) return;

    window._paq = window._paq || [];
    window._paq.push(["setCookieConsentGiven", false]); // DSGVO tracking without personal data
    window._paq.push(["disableCookies"]);
    window._paq.push(["trackPageView"]);
    window._paq.push(["enableLinkTracking"]);
    window._paq.push(["setTrackerUrl", `${trackerUrl}matomo.php`]);
    window._paq.push(["setSiteId", siteId]);

    if (!document.querySelector(`script[src="${trackerUrl}matomo.js"]`)) {
      const script = document.createElement("script");
      script.async = true;
      script.src = trackerScriptUrl;
      document.head.appendChild(script);
    }
  }, [siteId, trackerUrl, allowed]);
}
